import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Organization } from './organization.model';

import * as ACTIONS from './organizations.actions';

export const ORGANIZATIONS_FEATURE_KEY = 'organizations';

export const organizationsAdapter: EntityAdapter<Organization> = createEntityAdapter<Organization>({
    selectId: (organization) => organization.id
});

export interface OrganizationsState extends EntityState<Organization> {
    selectedOrganizationId: number | null;
    loading: boolean;
}

export const ORGANIZATIONS_INITIAL_STATE: OrganizationsState = organizationsAdapter.getInitialState({
    selectedOrganizationId: null,
    loading: false
});

export const organizationsReducer = createReducer(
    ORGANIZATIONS_INITIAL_STATE,

    on(ACTIONS.fetchOrganizations, (state) => ({
        ...state,
        loading: true
    })),
    on(ACTIONS.fetchOrganizationsSuccess, (state, { organizations }) =>
        organizationsAdapter.setAll(organizations, { ...state, loading: false })
    ),
    on(ACTIONS.fetchOrganizationsFailed, (state) => ({
        ...state,
        loading: false
    })),
    on(ACTIONS.selectOrganization, (state, { organizationId }) => ({
        ...state,
        selectedOrganizationId: parseInt(organizationId)
    })),
    on(ACTIONS.fetchOrganizationsByIds, (state) => ({
        ...state,
        loading: true
    })),
    on(ACTIONS.fetchOrganizationsByIdsSuccess, (state, { organizations }) =>
        organizationsAdapter.upsertMany(organizations, { ...state, loading: false })
    ),
    on(ACTIONS.fetchOrganizationsByIdsFailed, (state) => ({
        ...state,
        loading: false
    }))
);
